import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

import { AuthRouting } from './auth.routing';
import { AuthFetchService } from './fetch/service/auth.service';
import { HandleLoginService } from './handle-login.service';
import { LoginComponent } from './login/login.component';

const COMPONENT = [LoginComponent];

const SERVICES = [AuthFetchService, HandleLoginService];

const ANGULAR_MODULE = [CommonModule, FormsModule, ReactiveFormsModule];

const THIRD_MODULES = [TranslateModule];

export const routerModuleForChild: ModuleWithProviders = RouterModule.forChild(AuthRouting);

const NZ_MODULE = [
  NzDropDownModule,
  NzIconModule,
  NzMenuModule,
  NzFormModule,
  NzInputModule,
  NzButtonModule,
  NzGridModule,
  NzCheckboxModule,
  NzToolTipModule,
  NzSelectModule,
];

@NgModule({
  imports: [...ANGULAR_MODULE, ...THIRD_MODULES, ...NZ_MODULE, routerModuleForChild],
  declarations: [...COMPONENT],
  providers: [...SERVICES],
  exports: [...COMPONENT],
})
export class DtAuthModule {}
